var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isTranslationsInitDone
    ? _c(
        "div",
        [
          _vm.isTesterPage
            ? _c("router-view", { staticClass: "content-container" })
            : _c(
                "div",
                { staticClass: "vue-content" },
                [
                  _vm.notificationActive
                    ? _c("top-notification", {
                        attrs: { "notification-data": _vm.notificationData },
                        on: { closeNotification: _vm.closeNotification }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isMobile ||
                  (_vm.isSiteLoadDone && !_vm.site.isMenuHorizontalStyle)
                    ? _c("mega-menu", {
                        attrs: { "is-mega-menu-open": _vm.isMenuOpen },
                        on: { closeMegaMenu: _vm.closeMegaMenu }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("header-component", {
                    attrs: {
                      "is-showing-not-found-page": _vm.isShowingNotFoundPage,
                      "is-mega-menu-open": _vm.isMenuOpen
                    },
                    on: {
                      toggleMegaMenu: _vm.toggleMegaMenu,
                      closeMegaMenu: _vm.closeMegaMenu
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "transition",
                    { attrs: { name: "fade" } },
                    [
                      _vm.isShowingNotFoundPage
                        ? _c("not-found", { staticClass: "content-container" })
                        : !_vm.isShowingNotFoundPage && _vm.showSlotContent
                        ? _c(
                            "div",
                            { staticClass: "content-container" },
                            [_vm._t("default")],
                            2
                          )
                        : _c("router-view", {
                            key: _vm.$route.path,
                            staticClass: "content-container"
                          })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("footer-component"),
                  _vm._v(" "),
                  _vm.isCookieConsentNeeded ? _c("cookie-consent") : _vm._e()
                ],
                1
              )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }